// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".intraday-chart,\n.ytd-chart,\n.ten-yr-chart {\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/views/Panes/DashboardPane/Chart.css"],"names":[],"mappings":"AAAA;;;EAGE,kBAAkB;AACpB","sourcesContent":[".intraday-chart,\n.ytd-chart,\n.ten-yr-chart {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
